import { assetValueType } from "../../../constant";


const assetDetailsValueReducer = (state = false, action) => {
    switch (action.type) {
        case assetValueType.FETCH_ASSET_DETAILS_VALUE:
            return action.payload;
        default:
            return state;
    }
}
export default assetDetailsValueReducer